/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  GetUpdatedPaymentOperationsOverviewDto,
  PaymentOperationsDto,
  RetryFailedPspNotificationsDto,
  RetryNonCapturedPaymentsDto,
  RetryUnknownStatePaymentsDto,
} from '../models/index';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    GetUpdatedPaymentOperationsOverviewDtoFromJSON,
    GetUpdatedPaymentOperationsOverviewDtoToJSON,
    PaymentOperationsDtoFromJSON,
    PaymentOperationsDtoToJSON,
    RetryFailedPspNotificationsDtoFromJSON,
    RetryFailedPspNotificationsDtoToJSON,
    RetryNonCapturedPaymentsDtoFromJSON,
    RetryNonCapturedPaymentsDtoToJSON,
    RetryUnknownStatePaymentsDtoFromJSON,
    RetryUnknownStatePaymentsDtoToJSON,
} from '../models/index';

export interface ExcludeNonCapturedPaymentsFromWashingRequest {
    requestBody: Array<number>;
}

export interface GetUpdatedOverviewRequest {
    getUpdatedPaymentOperationsOverviewDto: GetUpdatedPaymentOperationsOverviewDto;
}

export interface RetryFailedPspNotificationsRequest {
    retryFailedPspNotificationsDto: RetryFailedPspNotificationsDto;
}

export interface RetryNonCapturedPaymentsRequest {
    retryNonCapturedPaymentsDto: RetryNonCapturedPaymentsDto;
}

export interface RetryUnknownStatePaymentsRequest {
    retryUnknownStatePaymentsDto: RetryUnknownStatePaymentsDto;
}

/**
 * 
 */
export class PaymentOperationsControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for excludeNonCapturedPaymentsFromWashing without sending the request
     */
    async excludeNonCapturedPaymentsFromWashingRequestOpts(requestParameters: ExcludeNonCapturedPaymentsFromWashingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling excludeNonCapturedPaymentsFromWashing().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-operations/non-captured-payments/exclude-from-washing`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        };
    }

    /**
     */
    async excludeNonCapturedPaymentsFromWashingRaw(requestParameters: ExcludeNonCapturedPaymentsFromWashingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOperationsDto>> {
        const requestOptions = await this.excludeNonCapturedPaymentsFromWashingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOperationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async excludeNonCapturedPaymentsFromWashing(requestParameters: ExcludeNonCapturedPaymentsFromWashingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOperationsDto> {
        const response = await this.excludeNonCapturedPaymentsFromWashingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getPaymentOperationsOverview without sending the request
     */
    async getPaymentOperationsOverviewRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-operations`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getPaymentOperationsOverviewRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOperationsDto>> {
        const requestOptions = await this.getPaymentOperationsOverviewRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOperationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getPaymentOperationsOverview(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOperationsDto> {
        const response = await this.getPaymentOperationsOverviewRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getUpdatedOverview without sending the request
     */
    async getUpdatedOverviewRequestOpts(requestParameters: GetUpdatedOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['getUpdatedPaymentOperationsOverviewDto'] == null) {
            throw new runtime.RequiredError(
                'getUpdatedPaymentOperationsOverviewDto',
                'Required parameter "getUpdatedPaymentOperationsOverviewDto" was null or undefined when calling getUpdatedOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-operations/updated`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUpdatedPaymentOperationsOverviewDtoToJSON(requestParameters['getUpdatedPaymentOperationsOverviewDto']),
        };
    }

    /**
     */
    async getUpdatedOverviewRaw(requestParameters: GetUpdatedOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOperationsDto>> {
        const requestOptions = await this.getUpdatedOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOperationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getUpdatedOverview(requestParameters: GetUpdatedOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOperationsDto> {
        const response = await this.getUpdatedOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for retryFailedPspNotifications without sending the request
     */
    async retryFailedPspNotificationsRequestOpts(requestParameters: RetryFailedPspNotificationsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['retryFailedPspNotificationsDto'] == null) {
            throw new runtime.RequiredError(
                'retryFailedPspNotificationsDto',
                'Required parameter "retryFailedPspNotificationsDto" was null or undefined when calling retryFailedPspNotifications().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-operations/failed-psp-notifications/retry`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetryFailedPspNotificationsDtoToJSON(requestParameters['retryFailedPspNotificationsDto']),
        };
    }

    /**
     */
    async retryFailedPspNotificationsRaw(requestParameters: RetryFailedPspNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOperationsDto>> {
        const requestOptions = await this.retryFailedPspNotificationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOperationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async retryFailedPspNotifications(requestParameters: RetryFailedPspNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOperationsDto> {
        const response = await this.retryFailedPspNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for retryNonCapturedPayments without sending the request
     */
    async retryNonCapturedPaymentsRequestOpts(requestParameters: RetryNonCapturedPaymentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['retryNonCapturedPaymentsDto'] == null) {
            throw new runtime.RequiredError(
                'retryNonCapturedPaymentsDto',
                'Required parameter "retryNonCapturedPaymentsDto" was null or undefined when calling retryNonCapturedPayments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-operations/non-captured-payments/retry`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetryNonCapturedPaymentsDtoToJSON(requestParameters['retryNonCapturedPaymentsDto']),
        };
    }

    /**
     */
    async retryNonCapturedPaymentsRaw(requestParameters: RetryNonCapturedPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOperationsDto>> {
        const requestOptions = await this.retryNonCapturedPaymentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOperationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async retryNonCapturedPayments(requestParameters: RetryNonCapturedPaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOperationsDto> {
        const response = await this.retryNonCapturedPaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for retryUnknownStatePayments without sending the request
     */
    async retryUnknownStatePaymentsRequestOpts(requestParameters: RetryUnknownStatePaymentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['retryUnknownStatePaymentsDto'] == null) {
            throw new runtime.RequiredError(
                'retryUnknownStatePaymentsDto',
                'Required parameter "retryUnknownStatePaymentsDto" was null or undefined when calling retryUnknownStatePayments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/payment-operations/unknown-state-payments/retry`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetryUnknownStatePaymentsDtoToJSON(requestParameters['retryUnknownStatePaymentsDto']),
        };
    }

    /**
     */
    async retryUnknownStatePaymentsRaw(requestParameters: RetryUnknownStatePaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentOperationsDto>> {
        const requestOptions = await this.retryUnknownStatePaymentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentOperationsDtoFromJSON(jsonValue));
    }

    /**
     */
    async retryUnknownStatePayments(requestParameters: RetryUnknownStatePaymentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentOperationsDto> {
        const response = await this.retryUnknownStatePaymentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
